import { Box, BoxProps, Typography, useTheme } from '@mui/material';
import { Check, Info, X } from 'lucide-react';
import { useCallback } from 'react';
import { DICOMApprovalStatus } from '~/domain/dicom/dicomstructureset';

export default function ReviewStatus({
    status,
    fontSize = 14,
    boxProps,
}: {
    status: DICOMApprovalStatus;
    fontSize?: number;
    boxProps?: BoxProps;
}) {
    const { palette } = useTheme();
    const getStatusLabel = useCallback(() => {
        switch (status) {
            case DICOMApprovalStatus.APPROVED:
                return (
                    <Box display="flex" alignItems="center">
                        <Check
                            style={{ marginRight: 4 }}
                            size={fontSize}
                            color={palette.success.main}
                        />
                        <Typography
                            fontSize={fontSize}
                            lineHeight={1.2}
                            mt="1px"
                        >
                            Approved
                        </Typography>
                    </Box>
                );
            case DICOMApprovalStatus.REJECTED:
                return (
                    <Box display="flex" alignItems="center">
                        <X
                            style={{ marginRight: 4 }}
                            size={fontSize}
                            color={palette.error.main}
                        />
                        <Typography
                            fontSize={fontSize}
                            lineHeight={1.2}
                            mt="1px"
                        >
                            Rejected
                        </Typography>
                    </Box>
                );
            default:
                return (
                    <Box display="flex" alignItems="center">
                        <Info
                            style={{ marginRight: 4 }}
                            size={fontSize}
                            color={palette.secondary.main}
                        />
                        <Typography
                            fontSize={fontSize}
                            lineHeight={1.2}
                            mt="1px"
                        >
                            Not reviewed
                        </Typography>
                    </Box>
                );
        }
    }, [status]);

    return (
        <Box display="flex" alignItems="center" {...boxProps}>
            {getStatusLabel()}
        </Box>
    );
}
